// @flow
import React from 'react';
import { WebView } from 'react-native-webview';
import { StyleSheet } from 'react-native';
import { ActivityIndicator } from 'trpc-react-native-ui';
import { FullScreenModal } from '../../common';
import { mobileEventChannel } from '../../../modules/Payment/sagas';
import theme from '../../../theme-config';
import WizzeeLog from '../../../lib/wizzeeLog';

type Props = {
  isVisible: boolean,
  stripeRedirectUrl: string,
};

export const ThreeDSecureAuthentModal = (props: Props) => {
  const { emitter } = mobileEventChannel;

  const handleShouldStartLoadWithRequest = ({ url }) => {
    if (url.includes('PaymentAuthorizationResult') && emitter) {
      emitter({ type: 'STRIPE_3DS_AUTH_COMPLETE' });
      return false; // Prevent WebView from navigating to the deep link URL
    }
    return true;
  };

  const renderActivityIndicator = () => <ActivityIndicator color={theme.neutral_darker} style={styles.loader} />;

  return (
    <FullScreenModal
      visible={props.isVisible}
      onRequestClose={() => emitter?.({ type: 'STRIPE_3DS_BROWSER_CANCELLED' })}
      containerStyle={styles.containerStyle}
    >
      {!props.stripeRedirectUrl ? (
        renderActivityIndicator()
      ) : (
        <WebView
          onShouldStartLoadWithRequest={handleShouldStartLoadWithRequest}
          source={{ uri: props.stripeRedirectUrl }}
          startInLoadingState
          renderLoading={renderActivityIndicator}
          javaScriptEnabled
          domStorageEnabled
          originWhitelist={['*']}
          mixedContentMode="compatibility"
          onError={(e) => WizzeeLog.warn('[ThreeDSecureAuthentModal] WebView error', e.nativeEvent)}
          onHttpError={(e) => WizzeeLog.warn('[ThreeDSecureAuthentModal] HTTP error', e.nativeEvent)}
        />
      )}
    </FullScreenModal>
  );
};

const styles = StyleSheet.create({
  loader: {
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
  containerStyle: {
    marginTop: 0,
  },
});
